import type { Agent } from '@studio/models/agent';
import {
  AgentDirectRequestUpdateRequest,
  AgentDirectRequestUpdateResponse
} from '@tryiris-ai/common.protojs/api/v1/agent_direct';
import { StudioError } from '#~/error/index.js';
import { nats } from '#~/nats/index.js';

/**
 * Update the software on the specified agent.
 *
 * @param agentId - The ID of the agent whose software is to be updated.
 */
export const update = async (agentId: Agent['id']): Promise<AgentDirectRequestUpdateResponse> => {
  try {
    const response = await nats.agentConnection(agentId).request(
      `direct.authenticated.${agentId}.update.request`,
      AgentDirectRequestUpdateRequest.encode({
        $type: 'api.v1.AgentDirectRequestUpdateRequest'
      }).finish(),
      { timeout: 5000 }
    );
    var r = AgentDirectRequestUpdateResponse.decode(response.data);
    if (!r) {
      throw new StudioError(`Unable to update agent`);
    }
    return r;
  } catch (cause) {
    throw new StudioError(`Unable to update agent: ${agentId}`, { cause });
  }
};
